<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon v-if="$acl.check('SuperAdmin')" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="confirmEditRecord" />
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="viewRecord" />


      <vs-prompt title="Edit Bank Account" accept-text="Edit" @cancel="clearValMultiple" @accept="editRecord"
      @close="close"  :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        
      


        <div class="mt-4 mb-2">
          <label class="vs-input--label"> Payment Status</label>
        <v-select  data-vv-validate-on="blur" placeholder="Select status of payment"
                  name="platform_name" v-model="status" v-validate="'required'" class="w-full"  label="statusName"
                  :options="statusOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>



  </div>
    </vs-prompt>



    </div>
</template>

<script>
  import vSelect from 'vue-select'

export default {

  name: 'CellRendererActions',
  components:{'v-select': vSelect,},
  data(){
    return{
      activePrompt: false,
      status:'',
       statusOptions:[
          {
            statusName: 'Unpaid',
            statusCode: 1
          },
          {
            statusName: 'Completed',
            statusCode: 2
          },
          {
            statusName: 'Canceled',
            statusCode: 3
          },
          {
            statusName: 'Pending',
            statusCode: 4
          },
          
      ],
    }
  },
  methods: {
    viewRecord () {
      this.$router.push(`/orders/${this.params.data.id}`).catch(() => {})
    },
    confirmEditRecord () {
      this.activePrompt = true;
      // this.$vs.dialog({
      //   type: 'confirm',
      //   color: 'primary',
      //   title: 'Confirm Delete',
      //   text: `You can just change the payment status of order number "${this.params.data.orderNumber})"`,
      //   accept: this.editRecord,
      //   acceptText: 'Edit'
      // })
    },
    clearValMultiple() {
      this.status = '';
    },
    close(){
     return true
    },
    editRecord () {
      /* UnComment below lines for enabling true flow if deleting user */
      const payload = new FormData();
      payload.append('orderId', this.params.data.id)
      payload.append('orderState', this.status.statusCode)
      this.$store.dispatch("order/editOrder", payload)
        .then((response)   => { 
          this.showEditSuccess(response.data)
          this.$store.dispatch('order/getAllOrders')
                    .then((response) => {
                        return true
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
                     })
        .catch(err => { console.warn(err)       })

    },
    showEditSuccess (data) {
      this.$vs.notify({
        color: 'success',
        title: 'Success',
        text: data.message
      })
    }
  }
}
</script>
